import { render, staticRenderFns } from "./detail_three.vue?vue&type=template&id=6056a7a0&scoped=true&"
import script from "./detail_three.vue?vue&type=script&lang=js&"
export * from "./detail_three.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056a7a0",
  null
  
)

export default component.exports